import { render, staticRenderFns } from "./QuestionTypeAll.vue?vue&type=template&id=283f40a0&scoped=true"
import script from "./QuestionTypeAll.vue?vue&type=script&lang=js"
export * from "./QuestionTypeAll.vue?vue&type=script&lang=js"
import style0 from "./QuestionTypeAll.vue?vue&type=style&index=0&id=283f40a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283f40a0",
  null
  
)

export default component.exports